import { Routes, Route, Navigate } from "react-router-dom";
import AppShell from "./components/AppShell";
import Directory from "./pages/Directory";
import Storefront from "./pages/Storefront";
import BuyerProfile from "./pages/BuyerProfile";
import Calendar from "./pages/Calendar";
import BattleCalculator from "./pages/BattleCalculator";
import About from "./pages/About";
import Auth from "./pages/Auth";
import Post from "./pages/Post";
import Me from "./pages/Me";
import NotFound from "./pages/NotFound";
import RolePick from "./pages/RolePick";
import UserProfile from "./pages/UserProfile";
import EditProfile from "./pages/EditProfile";

export default function App() {
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<Directory />} />
        <Route path="/seller/:handle" element={<Storefront />} />
        <Route path="/buyer/:handle" element={<BuyerProfile />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/calculator" element={<BattleCalculator />} />
        <Route path="/about" element={<About />} />
        {/* Three distinct auth intents; single component + mode prop. */}
        <Route path="/signin" element={<Auth mode="signin" />} />
        <Route path="/signup" element={<Auth mode="signup" />} />
        <Route path="/list" element={<Auth mode="list" />} />
        {/* Backwards-compat: /auth and /auth/finish both redirect to
            /signin. /auth/finish existed as the email-link landing page
            in the previous auth model; now that we're on Google +
            email/password, any surviving link just lands users on
            sign-in. */}
        <Route path="/auth/finish" element={<Navigate to="/signin" replace />} />
        <Route path="/auth" element={<Navigate to="/signin" replace />} />
        <Route path="/post" element={<Post />} />
        <Route path="/me" element={<Me />} />
        <Route path="/role-pick" element={<RolePick />} />
        <Route path="/me/edit" element={<EditProfile />} />
        <Route path="/u/:username" element={<UserProfile />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AppShell>
  );
}
